import { Button, HeadingText, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { mobileScreenSize } from '../../../utils/constants'

const Header = ({ windowWidth, sheetsStateSetter }) => {
  if (windowWidth <= mobileScreenSize) {
    return (
      <Fragment>
        <div className="tpp_top">
          <HeadingText size="lg">
            <Message id="thirdPartyPerm.heading" />
          </HeadingText>
        </div>
        <div className="helpTextDiv">
          <Message id="thirdPartyPerm.helpText1" />
          {/* <div> */}
          <Message id="thirdPartyPerm.helpText2" />
          <Link
            id="helpSheetsLink"
            data-pa-click="helpSheetsLink"
            onClick={() => sheetsStateSetter({ type: 'help', value: true })}
          >
            <Message id="thirdPartyPerm.thirdPartyPermissions" />
          </Link>
          {/* </div> */}
        </div>
        <Button
          className="tpp_addBtn mobile_addBtn"
          onClick={() => sheetsStateSetter({ type: 'grant', value: true })}
          id="addNewEntriesBtn"
          data-pa-click="addNewEntriesBtn"
        >
          <Message id="thirdPartyPerm.addApiUserButton" />
        </Button>
      </Fragment>
    )
  }
  return (
    <Fragment>
      <div className="tpp_top">
        <HeadingText size="lg">
          <Message id="thirdPartyPerm.heading" />
        </HeadingText>
        <Button
          className="tpp_addBtn"
          onClick={() => sheetsStateSetter({ type: 'grant', value: true })}
          id="addNewEntriesBtn"
          data-pa-click="addNewEntriesBtn"
        >
          <Message id="thirdPartyPerm.addApiUserButton" />
        </Button>
      </div>
      <div className="helpTextDiv">
        <Message id="thirdPartyPerm.helpText1" />
        {/* <div> */}
        <Message id="thirdPartyPerm.helpText2" />
        <Link
          id="helpSheetsLink"
          data-pa-click="helpSheetsLink"
          onClick={() => sheetsStateSetter({ type: 'help', value: true })}
        >
          <Message id="thirdPartyPerm.thirdPartyPermissions" />
        </Link>
        {/* </div> */}
      </div>
    </Fragment>
  )
}

Header.propTypes = {
  sheetsStateSetter: PropTypes.func,
  windowWidth: PropTypes.number,
}

export default Header
